export const VIEW_DATASET_SUMMARY = 'datasetSummaryView'
export const VIEW_DATASET_MEASUREMENT = 'datasetMeasurementView'
export const VIEW_DATASET_PLATESETUP = 'datasetPlateSetupView'
export const VIEW_DATA_REDUCTION_PANEL = 'dataReductionPanel'

export const SAMPLE_PLATE_LETTERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]
export const SAMPLE_PLATE_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
// action constants

// export const BUFFER_FRAME_TYPE = 'bufferFrameType';
// export const SAMPLE_FRAME_TYPE = 'sampleFrameType';
export const BUFFER_OR_SAMPLE_FRAME_TYPE = 'bufferOrSampleFrameType'
export const AVERAGE_BUFFER_FRAME_TYPE = 'averageBufferFrameType'
export const AVERAGE_SAMPLE_FRAME_TYPE = 'averageSampleFrameType'
export const SUBTRACTED_FRAME_TYPE = 'subtractedFrameType'

export const FRAME_SCALE_LOG = 'frameScaleIsLogarithmic'
export const FRAME_SCALE_LINEAR = 'frameScaleIsLinear'

export const FITTING_METHOD_FIR = 'FirFittingMethod'
export const FITTING_METHOD_FIT = 'FitFittingMethod'

export const CREATE_MACROMOLECULE_VIEW = 'createMacromoleculeView'
export const EDIT_MACROMOLECULE_VIEW = 'editMacromoleculeView'
export const MACROMOLECULE_WELCOME_VIEW = 'macromoleculeWelcomeView'

export const CREATE_BUFFER_VIEW = 'createBufferView'
export const EDIT_BUFFER_VIEW = 'editBufferView'
export const BUFFER_WELCOME_VIEW = 'bufferWelcomeView'
